import apimodulosweb from '@/services/api-recebimentoweb';
import * as STORAGE from '@/constants/STORAGE';
import storage from '@/services/storage';
import CryptoJS from 'crypto-js';

let findTimeout = null;
const verificacoesEmAndamento = new Set();

// Resultado das verificações de permissão do menu, feito uma vez por sessão pelo
// NavigationDrawer. Guardado aqui para que qualquer tela possa perguntar "esse cliente usa X?"
// sem chamar metodoAcesso de novo — que, se houver verificação da mesma rotina em andamento
// ou qualquer falha de rede, responde "bloqueado" e esconderia recurso de quem tem direito.
const ROTINAS_STORAGE = 'rotinas-liberadas';

function leRotinasDoStorage() {
  try {
    return JSON.parse(sessionStorage.getItem(ROTINAS_STORAGE)) ?? null;
  } catch (err) {
    return null;
  }
}

export default {
  namespaced: true,

  state: {
    list: [],

    // null = ainda não sabemos (as verificações não terminaram). Quem consome precisa
    // distinguir isso de "bloqueado" para não piscar recurso na tela.
    rotinasLiberadas: leRotinasDoStorage(),
  },

  getters: {
    list: (state) => state.list,

    // (rotina) => true liberada | false bloqueada | null ainda não sei
    rotinaLiberada: (state) => (rotina) => state.rotinasLiberadas?.[rotina] ?? null,

    // Enquanto não sabemos, trata como liberado: é o comportamento de sempre, e assim quem
    // usa condicional nunca vê o dado aparecer e sumir.
    condicionalLiberado: (state) => state.rotinasLiberadas?.MENU_CONDICIONAL !== false,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apimodulosweb.get('modulos', { params: { ...where, ...params } }),
        apimodulosweb.get('modulos/count', { params: where }),
      ]);

      return { data, total };
    },

    // CONSULTA COM CONTROLE DE CACHE
    async findWithCache({ commit, state }, { force, ttl } = {}) {
      if (!force && state.list?.length > 0) {
        return;
      }

      clearTimeout(findTimeout);

      const { data } = await apimodulosweb.get('modulos');

      commit('SET_LIST', data);

      if (ttl === Infinity) return;

      findTimeout = setTimeout(() => {
        commit('SET_LIST', null);
      }, ttl ?? 1000 * 60); // TTL -> Time To Live
    },

    // CONSULTA SEM CACHE
    async findById(_, { id }) {
      const { data } = await apimodulosweb.get(`modulos/${id}`);
      return data;
    },

    async findByAll(_, { objModulo }) {
      const { data } = await apimodulosweb.get(`modulos
      /${objModulo.moddescmodulo}
      /${objModulo.moddescprograma}
      /${objModulo.moddescrotina}
      `);
      return data;
    },

    async metodoAcesso(_, {
      nomeDescricao, nomeRotina, nomePrograma, nomeModulo,
    }) {
      const moduloJSON = {
        moddescmodulo: nomeModulo,
        moddescprograma: nomePrograma,
        moddescrotina: nomeRotina,
        moddescricao: nomeDescricao,
      };
      let userId = JSON.parse(await storage.getItem(STORAGE.USER_STORAGE.userId));
      const mult = (userId.toString()).slice(0, 3);
      userId = (userId.toString()).slice(3, 99);
      userId = ((userId - 1) / 11) - mult;
      const middleHash = userId + 74;

      // VERIFICA SE O MODULO JÁ EXISTE NO STORAGE
      let existe = false;
      let storageString = JSON.stringify(await storage.getItem(STORAGE.MODULOS_STORAGE.modulos));
      storageString = storageString.replace('"', '');
      const storageArray = storageString.split('|');
      const RotaMiddleHash = `${moduloJSON.moddescmodulo}/${moduloJSON.moddescprograma}/${moduloJSON.moddescrotina}/${middleHash}`;
      const HashRota = CryptoJS.SHA256(RotaMiddleHash).toString(CryptoJS.enc.Hex);
      for (let i = 0; i < storageArray.length; i += 1) {
        if (storageArray[i] === HashRota) {
          existe = true;
          break;
        }
      }

      let bloqueio = false;
      if (verificacoesEmAndamento.has(nomeRotina)) {
        return true;
      }

      verificacoesEmAndamento.add(nomeRotina);

      try {
        const multiplo = JSON.parse(sessionStorage.getItem('multiplosMenu')) || {};

        if (multiplo[nomeRotina]) {
          return true;
        }

        if (!existe && moduloJSON.moddescmodulo) {
          const { data } = await apimodulosweb.get(`modulos/${moduloJSON.moddescmodulo}/${moduloJSON.moddescprograma}/${nomeRotina}/${userId}`);

          if (!data) {
            await apimodulosweb.post('/modulos', moduloJSON);
            multiplo[nomeRotina] = true;
            sessionStorage.setItem('multiplosMenu', JSON.stringify(multiplo));

            bloqueio = true;
          } else if (data.peridusuario === userId) {
            if (storageString === 'null' || !storageString) storageString = '';
            storageString = storageString.replace('"', '');
            const novoStorage = `${storageString}${HashRota}|`;
            storage.setItem(STORAGE.MODULOS_STORAGE.modulos, (`${novoStorage}`));

            bloqueio = false;
          } else {
            bloqueio = true;
          }
          return bloqueio;
        }

        bloqueio = false;
        return bloqueio;
      } catch (error) {
        console.error(error);
        return true;
      } finally {
        verificacoesEmAndamento.delete(nomeRotina);
      }
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },

    SET_ROTINAS_LIBERADAS(state, rotinas) {
      state.rotinasLiberadas = rotinas ?? null;

      // Persistido para a resposta ser imediata ao navegar entre telas dentro da mesma
      // sessão, em vez de esperar o menu verificar tudo de novo a cada carga.
      try {
        sessionStorage.setItem(ROTINAS_STORAGE, JSON.stringify(rotinas ?? null));
      } catch (err) {
        // Sem storage a única perda é a piscada na primeira carga; não vale derrubar o menu.
      }
    },
  },
};
